module.exports = __webpack_public_path__ + "img/extermination-residentiel.7adec48d.jpg";